/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTguNSAwQzQuMDg0IDAgMC41IDMuNTg0IDAuNSA4QzAuNSAxMi40MTYgNC4wODQgMTYgOC41IDE2QzEyLjkxNiAxNiAxNi41IDEyLjQxNiAxNi41IDhDMTYuNSAzLjU4NCAxMi45MTYgMCA4LjUgMFpNMTIuNSA4LjhIOS4zVjEySDcuN1Y4LjhINC41VjcuMkg3LjdWNEg5LjNWNy4ySDEyLjVWOC44WiIgLz48L3N2Zz4=";